import React, { useMemo } from "react";
import ChartContainer from "../chart-container";
import lang from "translations";
import { Path } from "paths";
import styles from "./ranked-chart.module.scss";

const TopCategoriesBySalesChart = ({ ...props }) => {
  const data = useMemo(() => {
    return props.mappedData.map((p, index) => {
      const totalSales = `${p.unitSold || ""}`.trim();
      const [currency = "", ...amountParts] = totalSales.split(" ");

      return {
        id: p.id || `${p.name}-${index}`,
        rank: index + 1,
        name: p.name,
        categoryId: p.id,
        currency,
        amount: amountParts.join(" ") || totalSales,
      };
    });
  }, [props.mappedData]);
  const isEmpty = !props.mappedData.length;

  return (
    <ChartContainer
      title={{ to: Path.CATEGORY, name: lang.topCategoriesBySales }}
      {...props}
      empty={false}
      paddingless
      className={styles.card}
    >
      {isEmpty ? (
        <div className={styles.emptyState}>{lang.noDataAvailable}</div>
      ) : (
        <div className={styles.table}>
        <div className={styles.headerRow}>
          <span className="text-xs">{lang.category}</span>
          <span className="text-xs">{lang.totalSales}</span>
        </div>

        {data.map((category) => (
          <div className={styles.row} key={category.id}>
            <span className={styles.left}>
              <span className={styles.rank}>{category.rank}</span>
              {category.categoryId ? (
                <a className={`${styles.name} ${styles.link}`} href={`/product/category/${category.categoryId}`}>
                  {category.name}
                </a>
              ) : (
                <span className={styles.name}>{category.name}</span>
              )}
            </span>
            <span className={styles.value}>
              {category.currency ? <span className={styles.currency}>{category.currency}</span> : null}
              <span className="font-semibold text-base text-[var(--teal)]">{category.amount}</span>
            </span>
          </div>
        ))}
        </div>
      )}
    </ChartContainer>
  );
};

export default TopCategoriesBySalesChart;
